if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}


document.addEventListener('DOMContentLoaded', function () {

  const section = document.querySelector('.product-tabs-image');

  if (!section) return;

  const tabContents = section.querySelectorAll('.m-tab-content__inner');

  tabContents.forEach(content => {

    const textNodes = [...content.childNodes].filter(node => {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
    });

    textNodes.forEach(node => {

      const text = node.textContent.trim();

      if (!text.includes(';')) return;

      const items = text
        .split(';')
        .map(item => item.trim())
        .filter(item => item !== '');

      if (!items.length) return;

      const ul = document.createElement('ul');
      ul.classList.add('product-tabs-image__list');

      items.forEach(item => {
        const li = document.createElement('li');
        li.textContent = item;
        ul.appendChild(li);
      });

      node.parentNode.replaceChild(ul, node);

    });

  });

});